import React from 'react';
import cx from 'classnames';

import Container from '../container';
import NavBar from '../nav_bar';
import { NavigationItemProps } from '../../types';

import styles from './style.module.scss';

interface Props {
  darkMode?: boolean;
  isSticky: boolean;
  navigationItems: {
    items: NavigationItemProps[];
    supplementalItems: NavigationItemProps[];
  };
  navigationStyle?: any;
}

const StandaloneNavBar: React.FC<Props> = (props) => {
  return (
    <div
      className={cx(
        styles.standaloneNavBarContainer,
        { [styles.sticky]: props.isSticky, [styles.darkMode]: !!props.darkMode }
      )}
      style={{ zIndex: 15, ...(props.navigationStyle || {}) }}
    >
      <div>
        <Container>
          <NavBar
            darkMode={props.darkMode}
            isSticky={props.isSticky}
            navigationItems={props.navigationItems}
          />
        </Container>
      </div>
    </div>
  );
};

export default StandaloneNavBar;
